import { ApiCall } from "../apiBase";

/********get logged in user query********/
export async function getLoggedInUser() {
  let loggedInUser = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getLoggedInUser {
          getLoggedInUser {
            id
            firstName
            lastName
            email
          }
        }
      `,
    },
  });

  if (!result.data.errors && result.data.data.getLoggedInUser) {
    loggedInUser = result.data.data.getLoggedInUser;
  }

  return loggedInUser;
}

/********register user mutation********/
export async function registerUser(newUser) {
  let registerUserRes = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation register($input: UserRegisterInput!) {
            register(input: $input) {
                id
                firstName
                lastName
                email
            }
          }
        `,
      variables: {
        input: {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          password: newUser.password
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.register) {
    registerUserRes = result.data.data.register;
  }

  return registerUserRes;
}

/*******user login query********/
export async function login(userEmail, userPassword) {
    let loginRes = null;
  
    const result = await ApiCall({
      method: "post",
      data: {
        query: `
            query login($email: String!, $password: String!) {
              login(email: $email, password: $password) {
                  accessToken
                  expiresIn
              }
            }
          `,
        variables: {
          email: userEmail,
          password: userPassword
        },
      },
    });

    if (!result.data.errors && result.data.data.login) {
      loginRes = result.data.data.login;
    }

    return loginRes;
  }

